import { redirect } from '@tanstack/react-router';

const LOCAL_PLAYGROUND_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export function isLocalReferencePlaygroundHost(hostname: string | undefined): boolean {
  return LOCAL_PLAYGROUND_HOSTS.has((hostname ?? '').toLowerCase());
}

export function isReferencePlaygroundEnabled(hostname?: string): boolean {
  const browserHostname =
    hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : undefined);

  return (
    isLocalReferencePlaygroundHost(browserHostname) &&
    (import.meta.env.DEV || import.meta.env.VITE_ENABLE_REFERENCE_PLAYGROUND === '1')
  );
}

export function requireReferencePlaygroundAccess(): void {
  if (isReferencePlaygroundEnabled()) return;

  throw redirect({
    to: '/ask-argus',
    replace: true,
  });
}
